// LIST
export const FETCH_CARE_HOME_GROUPS =
  "app/CareHomeGroups/FETCH_CARE_HOME_GROUPS";
export const FETCH_CARE_HOME_GROUPS_SUCCESS =
  "app/CareHomeGroups/FETCH_CARE_HOME_GROUPS_SUCCESS";
export const FETCH_CARE_HOME_GROUPS_FAILURE =
  "app/CareHomeGroups/FETCH_CARE_HOME_GROUPS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/CareHomeGroups/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/CareHomeGroups/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/CareHomeGroups/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_CARE_HOME_GROUP = "app/CareHomeGroups/ADD_CARE_HOME_GROUP";
export const ADD_CARE_HOME_GROUP_SUCCESS =
  "app/CareHomeGroups/ADD_CARE_HOME_GROUP_SUCCESS";
export const ADD_CARE_HOME_GROUP_FAILURE =
  "app/CareHomeGroups/ADD_CARE_HOME_GROUP_FAILURE";
// EDIT
export const EDIT_CARE_HOME_GROUP = "app/CareHomeGroups/EDIT_CARE_HOME_GROUP";
export const EDIT_CARE_HOME_GROUP_SUCCESS =
  "app/CareHomeGroups/EDIT_CARE_HOME_GROUP_SUCCESS";
export const EDIT_CARE_HOME_GROUP_FAILURE =
  "app/CareHomeGroups/EDIT_CARE_HOME_GROUP_FAILURE";
// DELETE
export const DELETE_CARE_HOME_GROUP =
  "app/CareHomeGroups/DELETE_CARE_HOME_GROUP";
export const DELETE_CARE_HOME_GROUP_SUCCESS =
  "app/CareHomeGroups/DELETE_CARE_HOME_GROUP_SUCCESS";
export const DELETE_CARE_HOME_GROUP_FAILURE =
  "app/CareHomeGroups/DELETE_CARE_HOME_GROUP_FAILURE";
// SEARCH
export const SEARCH_CARE_HOME_GROUP =
  "app/CareHomeGroups/SEARCH_CARE_HOME_GROUP";
export const SEARCH_CARE_HOME_GROUP_SUCCESS =
  "app/CareHomeGroups/SEARCH_CARE_HOME_GROUP_SUCCESS";
export const SEARCH_CARE_HOME_GROUP_FAILURE =
  "app/CareHomeGroups/SEARCH_CARE_HOME_GROUP_FAILURE";
